import { UserFilterSerializable } from 'src/app/components/user-filter-dropdown/user-filter-selection';

export class SetDisplayedColumns {
  static readonly type = '[ActivitySummary] Set Displayed Columns';
  constructor(public displayedColumns: string[]) { }
}

export class SetDateType {
  static readonly type = '[ActivitySummary] Set Date Type';
  constructor(public dateType: string) { }
}

export class ActivitySummarySetTimezone {
  static type = '[ActivitySummary] Set Timezone';

  constructor(public timezone: string) { }
}

export class SetUserFilter {
  static readonly type = '[ActivitySummary] Set User Filter';
  constructor(public userFilter: UserFilterSerializable) { }
}
